import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("rect", {
        x: "9",
        y: "4.5",
        width: "6",
        height: "15",
        rx: "0.25",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M21,9.5a1,1,0,0,0,0-2H19.25A.25.25,0,0,1,19,7.25v-1A.25.25,0,0,1,19.25,6H21a1,1,0,0,0,0-2H19.25A.25.25,0,0,1,19,3.75V1.5A1.5,1.5,0,0,0,17.5,0H6.5A1.5,1.5,0,0,0,5,1.5V3.75A.25.25,0,0,1,4.75,4H3A1,1,0,0,0,3,6H4.75A.25.25,0,0,1,5,6.25v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75A.25.25,0,0,1,5,9.75v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3a1,1,0,0,0,0,2H4.75a.25.25,0,0,1,.25.25V22.5A1.5,1.5,0,0,0,6.5,24h11A1.5,1.5,0,0,0,19,22.5V20.25a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H21a1,1,0,0,0,0-2H19.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25Zm-4.5-6v17a.5.5,0,0,1-.5.5H8a.5.5,0,0,1-.5-.5V3.5A.5.5,0,0,1,8,3h8A.5.5,0,0,1,16.5,3.5Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }